<template>
  <div>
    <div>
      <div class="title">
        <gl-sub-text>明細表示形式</gl-sub-text>
      </div>
      <div class="content radio-buttons vertical">
        <md-radio v-model="_report" value="all">
          全件表示<gl-sub-text>（クラスターツリー順）</gl-sub-text>
        </md-radio>
        <md-radio v-model="_report" value="order">
          <div class="input-inline input-inline--within-radio">
            <label class="input-inline__label">採用順上位</label>
            <md-field class="input-inline__field input-inline__field--small">
              <md-input
                v-model.number="_orderValue"
                type="number"
                min="1"
              ></md-input>
            </md-field>
            <label class="input-inline__label">件表示</label>
          </div>
        </md-radio>
        <md-radio v-model="_report" value="customers">
          <div class="input-inline input-inline--within-radio">
            <label class="input-inline__label">累計購買者率</label>
            <md-field class="input-inline__field input-inline__field--small">
              <md-input
                v-model.number="_customerCountValue"
                type="number"
                min="1"
              ></md-input>
            </md-field>
            <label class="input-inline__label">
              ％までの採用順上位商品を表示
            </label>
          </div>
        </md-radio>
      </div>
      <div class="title">
        <gl-sub-text>R定義</gl-sub-text>
      </div>
      <div class="content input-inline">
        <md-field class="input-inline__field input-inline__field--small">
          <md-input v-model.number="_repeat" type="number" min="2"></md-input>
        </md-field>
        <label class="input-inline__label">回以上</label>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

/**
 * TapirMk用オプション選択コンポーネント
 */
export default {
  mixins: [ErrorReport],
  props: {
    report: {
      type: String,
      default: 'all',
      // * all = 全件表示
      // * order = 採用順上位x件
      // * customers = 累計購買者率x%まで
      validator: v => ['all', 'order', 'customers'].includes(v),
    },
    orderValue: {
      type: Number,
      default: 100,
      validator: v => v > 0,
    },
    customerCountValue: {
      type: Number,
      default: 100,
      validator: v => v > 0,
    },
    adoptOrder: {
      type: String,
      default: 'id_count',
      // * id_count = ID数
      // * coefficient_id_count = 加重平均ID数
      validator: v => ['id_count', 'coefficient_id_count'].includes(v),
    },
    repeat: {
      type: Number,
      default: 2,
      validator: v => v > 0,
    },
  },
  computed: {
    _report: {
      get() {
        return this.report
      },
      set(newVal) {
        this.$emit('update:report', newVal)
      },
    },
    _orderValue: {
      get() {
        return this.orderValue
      },
      set(newVal) {
        this.$emit('update:orderValue', newVal)
      },
    },
    _customerCountValue: {
      get() {
        return this.customerCountValue
      },
      set(newVal) {
        this.$emit('update:customerCountValue', newVal)
      },
    },
    _adoptOrder: {
      get() {
        return this.adoptOrder
      },
      set(newVal) {
        this.$emit('update:adoptOrder', newVal)
      },
    },
    _repeat: {
      get() {
        return this.repeat
      },
      set(newVal) {
        this.$emit('update:repeat', newVal)
      },
    },
    /**
     * 入力エラー
     */
    errors() {
      const errors = []

      // 採用順上位は自然数
      if (this._report === 'order') {
        if (this._orderValue < 1) {
          errors.push('採用順上位指定は1以上を入力してください。')
        } else if (!Number.isInteger(this._orderValue)) {
          errors.push('採用順上位指定は整数で入力してください。')
        }
      }

      // 累計購買者数は自然数
      if (this._report === 'customers') {
        if (this._customerCountValue < 1) {
          errors.push('累計購買者数指定は1以上を入力してください。')
        } else if (!Number.isInteger(this._customerCountValue)) {
          errors.push('累計購買者数指定は整数で入力してください。')
        }
      }

      // R定義は自然数
      if (this._repeat < 2) {
        errors.push('R定義は2以上を入力してください。')
      } else if (!Number.isInteger(this._repeat)) {
        errors.push('R定義は整数で入力してください。')
      }

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}

.radio-buttons {
  display: flex;

  &.vertical {
    flex-direction: column;
  }
}
</style>
